import { ComponentProps } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = ComponentProps<typeof Sonner>;

/**
 * Standard toast durations for consistent UX
 */
export const TOAST_DURATIONS = {
  SHORT: 3000,
  NORMAL: 5000,
  LONG: 8000,
  PERSISTENT: 0,
} as const;

/**
 * Toast position constants
 */
export const TOAST_POSITIONS = {
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right',
} as const;

/**
 * Standard toast options configuration with theme-aware styling
 */
export const sonnerToastOptions: ToasterProps['toastOptions'] = {
  classNames: {
    error: 'bg-destructive! text-destructive-foreground! border-destructive-foreground! border-1',
    warning: 'bg-warning! text-warning-foreground! border-warning-foreground! border-1',
    info: 'bg-secondary! text-secondary-foreground! border-secondary-foreground! border-1',
  },
  duration: TOAST_DURATIONS.NORMAL,
};

/**
 * Default Sonner configuration options
 */
export const defaultSonnerConfig: Partial<ToasterProps> = {
  position: 'bottom-right',
  // richColors: true,
  closeButton: true,
  expand: true,
  visibleToasts: 5,
  toastOptions: sonnerToastOptions,
};
